<template>
  <section class="section-login">
    <div class="row">
      <div class="col-12 text-left">
        <h2>{{ $t('message.login.reset_password') }}</h2>
        <p>{{ $t('message.login.reset_password_detail') }}</p>
        <div class="form-group mt-3">
          <input type="email"
                 class="form-control input-lg"
                 :class="{'form-alert': errorEmail}"
                 @input="updateFormData('email', $event)"
                 :placeholder="$t('message.login.email')"
                 v-model="email">
          <div v-if="errorEmail" class="form-alert-text -status-alert">{{ errorEmailText }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="button-large button-block -cyan" @click="checkEmailAccount">
          {{ isSendingEmail }}
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 text-left back-link">
        <a href="" @click.prevent="backToLogin">
          <i class="far fa-angle-left"></i> {{ $t('message.login.back_to_login') }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { firebaseAuth } from '../../helpers/firebaseHelpers'
  import { sendPasswordResetEmail } from 'firebase/auth'

  export default {
    data () {
      return {
        email: '',
        errorEmailText: '',
        errorEmail: false
      }
    },
    computed: {
      ...mapGetters({
        isCheckingEmailAccount: 'auth/getIsCheckingEmailAccount',
        state: 'auth/getState'
      }),
      isSendingEmail () {
        return (this.isCheckingEmailAccount) ? this.$i18n.t('message.button.sending') : this.$i18n.t('message.button.send_reset_link')
      }
    },
    watch: {
      isCheckingEmailAccount () {
        if (!this.isCheckingEmailAccount) {
          if (this.state.registeredPlatform) {
            const platform = this.state.registeredPlatform
            if (platform !== 'email_password') {
              const message = this.$i18n.t('message.alert.no_reset_email_for_other_platform', { platform: platform.charAt(0).toUpperCase() + platform.slice(1) })
              this.showAlertMessage(message)
            } else {
              this.sendResetPasswordLink()
            }
          } else {
            const message = this.$i18n.t('message.alert.no_email_for_reset_password')
            this.showAlertMessage(message)
          }
        }
      }
    },
    methods: {
      showAlertMessage (message) {
        this.$parent.$parent.showAlertMessage(message)
      },
      validation () {
        let result = true
        const emailFormat = new RegExp('^([a-zA-Z0-9\\+_\\-]+)(\\.[a-zA-Z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
        if (this.email === '') {
          this.errorEmailText = this.$i18n.t('message.login.email_is_required')
          this.errorEmail = true
          result = false
        } else if (this.email && !emailFormat.test(this.email)) {
          this.errorEmailText = this.$i18n.t('message.login.invalid_email_address')
          this.errorEmail = true
          result = false
        }

        return result
      },
      updateFormData (attribute, e) {
        if (attribute === 'email') {
          this.errorEmail = false
        }
      },
      backToLogin () {
        this.$store.commit('auth/SET_LOGIN_FORM_TYPE', 'login')
      },
      sendResetPasswordLink () {
        const email = this.email
        sendPasswordResetEmail(firebaseAuth, email).then(() => {
          // Email sent.
          this.showAlertMessage(null)
          alert(this.$i18n.t('message.login.sent_reset_password_link'))
          this.backToLogin()
        }, error => {
          let message = error.message
          if (error.code === 'auth/user-not-found') {
            message = this.$i18n.t('message.alert.no_email_for_reset_password')
          }
          this.showAlertMessage(message)
        })
      },
      checkEmailAccount () {
        if (this.validation()) {
          const submitData = {
            email: this.email
          }
          this.isSending = true
          this.$store.dispatch('auth/CHECK_EMAIL_ACCOUNT', submitData)
        }
      }
    },
    mounted () {
      this.email = ''
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/ResetPasswordForm.vue